// extracted by mini-css-extract-plugin
export default {"promotion-badge":"PromotionBadge_promotion-badge__28o-F"};